export default __webpack_public_path__ + "static/media/icon-person-biometry-male.9299d4ec.svg";